module.exports = __webpack_public_path__ + "static/media/lose.395da7b9.mp3";